import React, { Fragment } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ListIcon, HomeIcon, UsersIcon, EyeIcon, FileTextIcon, CheckCircleIcon, ChevronRightIcon } from 'lucide-react';
import { useRental } from '../../contexts/RentalContext';
export function RentalFlowTracker() {
  const location = useLocation();
  const {
    getStats
  } = useRental();
  const stats = getStats();
  const flowSteps = [{
    id: 'prospecting',
    label: 'Prospectare',
    shortLabel: 'Prosp.',
    icon: ListIcon,
    path: '/inchiriere/liste-prospectare',
    count: stats.totalProspectingLeads,
    countLabel: 'leaduri',
    color: 'bg-[#357BEB]',
    gradient: 'from-blue-500 to-indigo-600',
    lightColor: 'bg-blue-50'
  }, {
    id: 'listings',
    label: 'Anunțuri',
    shortLabel: 'Anunț.',
    icon: HomeIcon,
    path: '/inchiriere/anunturi',
    count: stats.activeListings,
    countLabel: 'active',
    color: 'bg-[#21A366]',
    gradient: 'from-emerald-500 to-teal-600',
    lightColor: 'bg-green-50'
  }, {
    id: 'leads',
    label: 'Leaduri',
    shortLabel: 'Lead.',
    icon: UsersIcon,
    path: '/inchiriere/leaduri',
    count: stats.activeTenantLeads,
    countLabel: 'active',
    color: 'bg-[#FF6B35]',
    gradient: 'from-orange-500 to-red-600',
    lightColor: 'bg-orange-50'
  }, {
    id: 'viewings',
    label: 'Vizionări',
    shortLabel: 'Viz.',
    icon: EyeIcon,
    path: '/inchiriere/vizionari',
    count: stats.todayViewings,
    countLabel: 'azi',
    color: 'bg-[#357BEB]',
    gradient: 'from-blue-500 to-indigo-600',
    lightColor: 'bg-blue-50'
  }, {
    id: 'contracts',
    label: 'Contracte',
    shortLabel: 'Contr.',
    icon: FileTextIcon,
    path: '/inchiriere/contracte',
    count: 3,
    countLabel: 'în lucru',
    color: 'bg-purple-600',
    gradient: 'from-purple-500 to-pink-600',
    lightColor: 'bg-purple-50'
  }, {
    id: 'transactions',
    label: 'Tranzacții',
    shortLabel: 'Tranz.',
    icon: CheckCircleIcon,
    path: '/tranzactii',
    count: 5,
    countLabel: 'finalizate',
    color: 'bg-[#21A366]',
    gradient: 'from-emerald-500 to-teal-600',
    lightColor: 'bg-green-50'
  }];
  const isStepActive = (path: string) => {
    if (path === '/tranzactii') return location.pathname.startsWith(path);
    return location.pathname.startsWith(path);
  };
  const getCurrentStepIndex = () => {
    return flowSteps.findIndex(step => isStepActive(step.path));
  };
  const currentStepIndex = getCurrentStepIndex();
  return;
}